import { dossierTypeEnum } from "../../common/constants/dossierTypeEnum";
import { helpTypeCopy } from "./helpType.copy";

export interface HelpTypeOption {
    label: string;
    value: dossierTypeEnum;
    image?: string;
    svg?: string;
    introduction: string;
    requiresHailMode?: boolean;
}

export const helpTypes: HelpTypeOption[] = [
    {
        label: helpTypeCopy.types.hail.label,
        value: dossierTypeEnum.HailDamage,
        image: "autoschade.svg",
        introduction: helpTypeCopy.types.hail.introduction,
        requiresHailMode: true,
    },
    {
        label: helpTypeCopy.types.body.label,
        value: dossierTypeEnum.BodyRepair,
        image: "autoschade.svg",
        introduction: helpTypeCopy.types.body.introduction,
    },
    {
        label: helpTypeCopy.types.glass.label,
        value: dossierTypeEnum.GlassRepair,
        svg: "ruitschade.svg",
        introduction: helpTypeCopy.types.glass.introduction,
    },
    {
        label: helpTypeCopy.types.caravan.label,
        value: dossierTypeEnum.CaravanRepair,
        svg: "caravan-en-camperschade.svg",
        introduction: helpTypeCopy.types.caravan.introduction,
    },
];
